/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eta_Window_EveningInputs */

const en_eta_window_evening = /** @type {(inputs: Eta_Window_EveningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After 18:00`)
};

const ja_eta_window_evening = /** @type {(inputs: Eta_Window_EveningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18時以降`)
};

const fr_eta_window_evening = /** @type {(inputs: Eta_Window_EveningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Après 18h00`)
};

const de_eta_window_evening = /** @type {(inputs: Eta_Window_EveningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach 18:00`)
};

/**
* | output |
* | --- |
* | "After 18:00" |
*
* @param {Eta_Window_EveningInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const eta_window_evening = /** @type {((inputs?: Eta_Window_EveningInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eta_Window_EveningInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eta_window_evening(inputs)
	if (locale === "ja") return ja_eta_window_evening(inputs)
	if (locale === "fr") return fr_eta_window_evening(inputs)
	return de_eta_window_evening(inputs)
});